import React from 'react';
import { useEffect, useState } from 'react';
import Service from '../services/anagrafica/Accessoutenteservice';
import Translate from './Translate';
//import dateIt from './utils/dateIt'

function Userinfo() {

    useEffect(() => {
        Service.me().then(response => {
            setUserInfo(response.data);
        });
    }, []);
    const [userInfo, setUserInfo] = useState(null);

    if (!userInfo) {
        return null;
    }

    return (
        <span className="p-3" style={{ fontSize: '80%', backgroundColor: '#fff' }}>
            <Translate chiave="WELCOME" pacchetto="Site" />
            : {userInfo.username}</span>
    );

    /*
        const infoLastLogin = userInfo.dataUltimoLogin ?
            'Ultimo accesso: ' + dateIt(userInfo.dataUltimoLogin)
            : 'Questo è il tuo primo accesso.';
        return (
            <span className="pr-3">Benvenuto/a {userInfo.username}. <small>{infoLastLogin}</small></span>
        );*/
}

export default Userinfo;